"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),s=require("../styles.js");const t=e.css`
    .details-pane-secondary--toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .details-pane-secondary--toggle-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        padding: 12px;
        border-radius: 3px;
    }
    ${s.responsive("sm",e.css`
            .details-pane-secondary--toggle {
                display: none;
            }
        `)}
`;exports.default=t,exports.stylesModelDetailsToggle=t;
//# sourceMappingURL=styles.js.map
